import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import DashboardNavbar from '../dashboardNavbar';
import { Card, Btn } from '../ui/primitives';
import { Icon } from '../ui/shell';

/* ============================================================
   Analysis workspace — legacy route.

   Per design handoff, Yaki course analysis lives on Course Detail
   → Analysis tab. This page redirects when opened with a course
   in location.state; otherwise it explains where to find analysis.
   ============================================================ */

const Shell = styled.div`
  min-height: calc(100vh - 32px);
  margin: 0 auto;
  padding: 0 28px 36px;
  color: ${({ theme }) => theme.text};
  font-family: ${({ theme }) => theme.fontBody};
  @media (max-width: 768px) { padding: 0 14px 28px; }
`;

const Hero = styled.div`
  width: min(1180px, 100%);
  margin: ${({ theme }) => theme.space} auto ${({ theme }) => theme.gap};
  h2 { margin: 0; color: ${({ theme }) => theme.text}; font-family: ${({ theme }) => theme.fontHead}; font-size: 16px; font-weight: 700; letter-spacing: -.01em; }
  p { margin: 2px 0 0; color: ${({ theme }) => theme.textMuted}; font-size: ${({ theme }) => theme.fsSm}; }
`;

const Wrap = styled.div`
  width: min(1180px, 100%);
  margin: 0 auto;
`;

const ANALYSIS_TABS = [
  { title: 'Analyse All', link: '/Portal/Instructor/analysis' },
];

const AnalysisPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const preset = location.state || {};
  const presetCourse = preset.course;

  useEffect(() => {
    if (presetCourse) {
      navigate('/Portal/Instructor/CourseDetail', {
        replace: true,
        state: { course: presetCourse, tab: 'analysis', scope: preset.scope },
      });
    }
  }, [navigate, presetCourse, preset.scope]);

  if (presetCourse) return null;

  return (
    <Shell>
      <DashboardNavbar menuItems={ANALYSIS_TABS} />
      <Hero>
        <h2>Analysis</h2>
        <p>Yaki course analysis is available on each course&apos;s detail page.</p>
      </Hero>
      <Wrap>
        <Card $pad style={{ maxWidth: 520 }}>
          <p style={{ margin: '0 0 16px', fontSize: 13, lineHeight: 1.6, color: 'inherit' }}>
            Open a course from the catalog, then select the <strong>Analysis</strong> tab — or click <strong>Analyze Course</strong> on the course hero.
          </p>
          <Btn onClick={() => navigate('/Portal/Instructor/Course')}>
            <Icon name="course" size={16} />Go to courses
          </Btn>
        </Card>
      </Wrap>
    </Shell>
  );
};

export default AnalysisPage;
